/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Forbiddendescription1Inputs */

const zh_learn_forbiddendescription1 = /** @type {(inputs: Learn_Forbiddendescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你当前的账户无法访问该分享内容。`)
};

const en_learn_forbiddendescription1 = /** @type {(inputs: Learn_Forbiddendescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This shared session is not available with your current account.`)
};

const es_learn_forbiddendescription1 = /** @type {(inputs: Learn_Forbiddendescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta sesión compartida no está disponible con tu cuenta actual.`)
};

/**
* | output |
* | --- |
* | "This shared session is not available with your current account." |
*
* @param {Learn_Forbiddendescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_forbiddendescription1 = /** @type {((inputs?: Learn_Forbiddendescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Forbiddendescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_forbiddendescription1(inputs)
	if (locale === "en") return en_learn_forbiddendescription1(inputs)
	return es_learn_forbiddendescription1(inputs)
});
export { learn_forbiddendescription1 as "learn_forbiddenDescription" }